import { Documents } from '@/types/company';
import {
  Card,
  CardContent,
  List,
  ListItem,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export const PoaDocumentCard = ({
  document,
}: {
  document: Documents.DocumentType;
}) => {
  const { t } = useTranslation();
  const companyName = document?.data?.Company_Name;
  const companyOrgNo = document?.data?.Org_No;
  const userName = document?.data?.User_Name;
  const userPersonalNo = document?.data?.User_Identity_Reference;
  return (
    <Card
      sx={{
        borderRadius: 3,
        padding: { xs: 2, sm: 5 },
        boxShadow: 'none',
        border: 1,
        borderColor: 'grey.200',
      }}>
      <CardContent sx={{ padding: 0 }}>
        <Stack gap={2}>
          <Typography variant="h5">{t('power_of_attorney')}</Typography>
          <Stack gap={1}>
            <Typography variant="body1">
              {t('poa_document_body', {
                companyName,
                companyOrgNo,
                userName,
                userPersonalNo,
              })}
            </Typography>
            <List sx={{ listStyle: 'decimal', paddingLeft: 3, margin: 0 }}>
              <ListItem sx={{ display: 'list-item', padding: 0 }}>
                <Typography variant="body1">
                  {t('poa_document_body_list_1')}
                </Typography>
              </ListItem>
              <ListItem sx={{ display: 'list-item', padding: 0 }}>
                <Typography variant="body1">
                  {t('poa_document_body_list_2')}
                </Typography>
              </ListItem>
              <ListItem sx={{ display: 'list-item', padding: 0 }}>
                <Typography variant="body1">
                  {t('poa_document_body_list_3')}
                </Typography>
              </ListItem>
            </List>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
